<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" :disabled="multiple"
            v-preventReClick @click="handleDelete">删除</el-button>
          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData"
            v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="print">
            <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
              打印
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">打印</el-dropdown-item>
              <el-dropdown-item command="1">预览</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-button v-if="tableAcl.indexOf('FinishOrder') != -1" class="btn" size="small" :disabled="multiple"
            v-preventReClick @click="showFinishOrdersDialog">关闭订单</el-button>

          <BatchApproval v-if="tableAcl.indexOf('BatchApproves') != -1" :multipleSelectionList="multipleSelection"
            :batchApproval="batchApproval" @getData="getData" @reset="reset" />

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
            @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>
      <div style="margin-bottom: 10px">
        <el-tabs v-model="query.state" @tab-click="tabClick" stretch>
          <el-tab-pane v-for="item in PurchaseOrderStateArray" :key="item.id" :name="item.id + ''">
            <template slot="label">
              <el-badge :value="item.count" :max="99" class="item">
                <span style="margin: 0 10px"> {{ item.name }} </span>
              </el-badge>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-if="tableHaeder.length > 0">
        <CustomTable ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange"
          :tableHaeder="tableHaeder" :loading="loading" @resetMethod="reset" :tableHeight="tableHeight"
          @onApproveStatusSuccess="getData" :tableCode="route.name">
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">
            <el-table-column fixed="right" prop="operation" label="操作" width="180">
              <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
                <el-button v-if="
                  scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)
                " type="text" v-preventReClick @click="handleApprove(scope.row)"
                  class="margin-left20 color-blue">审核</el-button>
                <el-button v-else-if="
                  scope.row.status != 1 &&
                  scope.row.status != 2 &&
                  tableAcl.indexOf('Edit') != -1
                " type="text" v-preventReClick @click="handleUpdate(scope.row)"
                  class="margin-left20 color-blue">编辑</el-button>
                <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
                <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick
                  @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
                <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
                <el-button type="text" v-preventReClick v-if="scope.row.status == 2 && scope.row.sendState == 0"
                  @click="sendToMaster(scope.row)" class="margin-left20 color-blue">推送</el-button>
                <el-button type="text" v-preventReClick v-if="
                  tableAcl.indexOf('FinishOrder') != -1 &&
                  scope.row.status == 2 &&
                  scope.row.sendState == 1 &&
                  [7, 8, 9,10,2].indexOf(scope.row.state) == -1
                " @click="finishOrder(scope.row)" class="margin-left20 color-blue">关闭订单</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
      <div v-else>
        <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData"
          :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe
          :header-cell-style="{ background: '#DDEBFF' }">
          <template slot="empty">
            <div class="empty-div" :style="{ height: tableHeight + 'px' }">
              <img src="../../../../assets/noData.png" width="240" height="240" />
              <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
              <div class="empty-rest" @click="reset">恢复默认</div>
            </div>
          </template>
          <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
          </el-table-column>
          <el-table-column width="175" prop="no" label="采购订单号">
            <template slot-scope="scope">
              <span>
                <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="pressingStateName" width="80" label="紧急标识">
            <template slot-scope="scope">
              <span :class="getPressingStateClass(scope.row.pressingState)">{{
                scope.row.pressingStateName
                }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="categoryName" width="120" label="采购类型">
          </el-table-column>  
          <el-table-column show-overflow-tooltip width="150" prop="supplierName" label="供应商"></el-table-column>
          <!-- <el-table-column prop="pressingStateName" width="80" label="紧急标识"></el-table-column> -->
          <el-table-column width="100" prop="createdUserName" label="发起人"></el-table-column>
          <el-table-column width="120" prop="stateName" label="订单状态"></el-table-column>
          <el-table-column prop="createdTime" label="创建时间" min-width="170">
            <template slot-scope="scope">
              {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
            </template>
          </el-table-column>
          <el-table-column width="110" prop="deliveryTime" label="要求送达日期">
            <template slot-scope="scope">{{
              parseTime(new Date(scope.row.deliveryTime), "{y}-{m}-{d}")
              }}</template>
          </el-table-column>
          <el-table-column width="120" prop="totalNumber" label="总数量"></el-table-column>
          <el-table-column width="120" prop="totalAmount" label="总金额"></el-table-column>
          <el-table-column label="审批人" width="100" align="center" prop="approverNames">
            <template slot-scope="scope">
              <span>{{ scope.row.approverNames?scope.row.approverNames:'-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="statusName" label="流程状态" width="80">
            <template slot-scope="scope">
              <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions"
                @success="getData" :tableCode="route.name"></approve-status>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.remark?scope.row.remark:'-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="oneLevelWarehouseInfo" label="收货信息" min-width="160"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.oneLevelWarehouseInfo?scope.row.oneLevelWarehouseInfo:'-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="purchasePlanNos" label="来源采购计划单号" min-width="140"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.purchasePlanNos?scope.row.purchasePlanNos:'-' }}</span>
            </template>
          </el-table-column>
          <el-table-column width="170" prop="updateTime" label="最后更新时间">
            <template slot-scope="scope">{{
              parseTime(new Date(scope.row.updateTime), "{y}-{m}-{d} {h}:{i}:{s}")
              }}</template>
          </el-table-column>
          <el-table-column fixed="right" width="80" prop="printingTimes" label="打印次数"></el-table-column>
          <el-table-column fixed="right" width="160" label="完成情况">
            <template slot-scope="scope">
              <el-progress :text-inside="true" :stroke-width="20" :percentage="getPercentage(scope.row.totalInStockNumber, scope.row.totalOrderNumber)
                " color="#42b983" />
            </template>
          </el-table-column>
          <el-table-column fixed="right" prop="operation" label="操作" width="180">
            <template slot-scope="scope">
              <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
              <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text"
                v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
              <el-button v-else-if="
                scope.row.status != 1 &&
                scope.row.status != 2 &&
                tableAcl.indexOf('Edit') != -1
              " type="text" v-preventReClick @click="handleUpdate(scope.row)"
                class="margin-left20 color-blue">编辑</el-button>
              <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
              <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick
                @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
              <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
              <el-button type="text" v-preventReClick v-if="scope.row.status == 2 && scope.row.sendState == 0"
                @click="sendToMaster(scope.row)" class="margin-left20 color-blue">推送</el-button>
              <el-button type="text" v-preventReClick v-if="
                tableAcl.indexOf('FinishOrder') != -1 &&
                scope.row.status == 2 &&
                scope.row.sendState == 1 &&
                [7, 8, 9,10,2].indexOf(scope.row.state) == -1
              " @click="finishOrder(scope.row)" class="margin-left20 color-blue">关闭订单</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- <info :show="showInfo" :id="id" @handleClose="closeInfo"></info> -->
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <el-dialog :title="finishOrderDialogTitle" :visible.sync="showFinishOrderDialog" width="640px">
      <el-form ref="finishForm" :model="finishForm" label-width="80px" :rules="finishRules">
        <el-row>
          <el-form-item label="原因" prop="remark">
            <el-input v-model="finishForm.remark"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn primary" type="primary" v-preventReClick @click="finishSubmit">确 定</el-button>
        <el-button class="btn default" v-preventReClick @click="showFinishOrderDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="订单送达日期预警" :visible.sync="isIncompleteOrdersDueSoon" :close-on-press-escape="false"
      :close-on-click-modal="false" width="50%">
      <el-table border row-key="id" :data="isIncompleteOrdersDueSoonData" style="width: 100%" stripe max-height="500"
        :header-cell-style="{ background: '#DDEBFF' }">
        <el-table-column width="175" prop="no" label="采购订单号"></el-table-column>
        <el-table-column prop="pressingStateName" width="80" label="紧急标识">
          <template slot-scope="scope">
            <span :class="getPressingStateClass(scope.row.pressingState)">{{
              scope.row.pressingStateName
              }}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="deptName" label="需求科室"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="150" prop="supplierName" label="供应商"></el-table-column>
        <el-table-column width="120" prop="stateName" label="订单状态"></el-table-column>
        <el-table-column width="110" prop="deliveryTime" label="要求送达日期">
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.deliveryTime), "{y}-{m}-{d}")
            }}</template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <div>
          <el-checkbox v-model="checked"></el-checkbox>
          <span> 今日不再提醒</span>
        </div>
        <el-button type="primary" @click="yesClick">我知道了</el-button>
      </div>
    </el-dialog>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  GetPurchaseOrders,
  GetPurchaseOrderPrintData,
  RemovePurchaseOrder,
  ExportPurchaseOrder,
  SendToMaster,
  FinishPurchaseOrder,
  FinishPurchaseOrders,
  ApprovePurchaseOrders,
  GetIncompleteOrdersDueSoon,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import Info from './info';
import {
  PurchaseCategoryOptions,
  OrderStateOptions,
  WhetherOptions,
  ApproveStatusOptions,
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";
import BatchApproval from "@/components/batchApproval";
export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
    BatchApproval,
  },
  data() {
    return {
      GetDatasAction: GetPurchaseOrders,
      RemoveAction: RemovePurchaseOrder,
      PrintAction: GetPurchaseOrderPrintData,
      editPath: "purchase-order-edit",
      exportAction: ExportPurchaseOrder,
      batchApproval: ApprovePurchaseOrders,
      // // 查询条件
      // query: {
      //   keyWord: "",
      //   pageSize: 10,
      //   pageIndex: 1,
      // },
      // // 列表数据
      // tableData: [],
      // // 列表总数
      // total: 0,
      // // 弹出框标题
      // title: "",
      // // 弹出编辑框
      // open: false,
      // // 打开详情
      // showInfo: false,
      // id: 0,
      // // 多选框数据
      // ids: [],
      // multipleSelection: [],
      // // 列表多选
      // multiple: true,

      PurchaseCategoryOptions: PurchaseCategoryOptions,
      OrderStateOptions: OrderStateOptions,
      WhetherOptions: WhetherOptions,
      ApproveStatusOptions: ApproveStatusOptions,
      filterOptions: [
        {
          name: "订单号",
          type: "input",
          code: "keyWord",
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "供应商",
          type: "select",
          code: "supplierId",
          filterMethod: this.getSuppliers,
          data: [],
        },
        {
          name: "生产厂家",
          type: "select",
          code: "manufacturerId",
          filterMethod: this.getManufacturers,
          data: [],
        },
        {
          name: "来源采购计划单号",
          type: "input",
          code: "purchasePlanNo",
        },

        // {
        //   name: "订单状态",
        //   type: "select",
        //   code: "states",
        //   data: OrderStateOptions,
        //   multiple: true
        // },
        {
          name: "采购类型",
          type: "select",
          code: "categorys",
          data: PurchaseCategoryOptions,
          multiple: true,
        },
        {
          name: "供货商产品",
          type: "select",
          code: "supplierProductId",
          filterMethod: this.getSupplierProductsNoDebounce,
          data: [],
        },
        {
          name: "是否自动生成",
          type: "select",
          code: "isAutoCreated",
          data: WhetherOptions,
          defaultValue: 0,
        },
        {
          name: "创建时间",
          type: "date",
          code: "date",
        },
        {
          name: "流程状态",
          type: "select",
          code: "statuses",
          multiple: true,
          data: ApproveStatusOptions,
        },
        {
          name: "最后更新时间",
          type: "date",
          code: "updateTime",
          startDateCode: "updateTimeStart",
          endDateCode: "updateTimeEnd",
        },
        {
          name: "主条码",
          type: "input",
          code: "mainNo",
        },
        {
          name: "要求送达日期",
          type: "date",
          code: "deliveryDate",
          startDateCode: "deliveryDateStart",
          endDateCode: "deliveryDateEnd",
        },
            {
            name: "二级供应商",
            type: "input",
            code: "secondSupplierName",
        },
        // {
        //   name: "来源采购计划单号",
        //   type: "input",
        //   code: "sourcePurchasePlanNo",
        // },
      ],
      showFinishOrderDialog: false,
      finishOrderDialogTitle: "",
      finishForm: {},
      finishRules: {
        remark: [
          {
            required: true,
            message: "请输入原因",
            trigger: "blur",
          },
        ],
      },
      isIncompleteOrdersDueSoon: false,
      isIncompleteOrdersDueSoonData: [],
      checked: false,
    };
  },
  methods: {
    sendToMaster(row) {
      SendToMaster({
        id: row.id,
      }).then((res) => {
        if (!res.successful) {
          return;
        }
        this.getData();
        this.$my_message("推送成功", "success");
      });
    },

    finishOrder(row) {
      this.showFinishOrderDialog = true;
      this.finishOrderDialogTitle = "是否关闭当前采购订单【" + row.no + "】";
      this.finishForm = {
        ids: [row.id],
        no: row.no,
        remark: "",
      };
    },
    showFinishOrdersDialog() {
      let errorList = this.multipleSelection.filter(
        (e) => e.state == 7 || e.state == 8 || e.state == 9
      );
      if (errorList && errorList.length > 0) {
        this.$my_message("请选择状态不等于已收货、已取消、已关闭的订单", "warning");
        return;
      }

      this.showFinishOrderDialog = true;
      this.finishOrderDialogTitle = "是否关闭当前已选择的采购订单";
      this.finishForm = {
        ids: this.ids,
        remark: "",
      };
    },
    finishSubmit() {
      this.$refs.finishForm.validate((valid) => {
        if (valid) {
          FinishPurchaseOrders(this.finishForm).then((res) => {
            if (!res.successful) {
              return;
            }
            this.showFinishOrderDialog = false;
            this.getData();
            this.$my_message(res.errorMessage, "success");
          });
        }
      });
    },
    tabClick() {
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;
      if (this.$refs.customTable) {
        this.$refs.customTable.callChildMethod().clearSelection();
      }
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      // this.$set(this.query, 'appId', id);
      this.getData();
    },
    getIncompleteOrdersDueSoon() {
      GetIncompleteOrdersDueSoon().then((res) => {
        if (res.successful&&res.returnData.length==0) {
          return;
        }
        this.isIncompleteOrdersDueSoonData = res.returnData;
        this.isIncompleteOrdersDueSoon = true;
      });
    },
    yesClick() {
      console.log(this.checked);

      if (this.checked == true) {
        const currentTimestamp = Date.now();
        const oneDayLaterTimestamp = currentTimestamp + 86400000;
        console.log(oneDayLaterTimestamp);

        localStorage.setItem("noRemindPurchaseOrder", oneDayLaterTimestamp);
      }
      this.isIncompleteOrdersDueSoon = false;
    },
  },
  created() {
    this.query.state = "-1";
    // 分页组件默认值需要早created
    if (this.$route.params && JSON.stringify(this.$route.params) != "{}") {
      this.query = this.$route.params;
    }
  },
  mounted() {
    let noRemindPurchaseOrder = localStorage.getItem("noRemindPurchaseOrder") ?? 0;

    if (noRemindPurchaseOrder < Date.now()) {
      this.getIncompleteOrdersDueSoon();
    }
    // 查询组件默认值需要在mounted
    if (this.$route.params && JSON.stringify(this.$route.params) != "{}") {
      for (var property in this.$route.params) {
        this.$set(this.query, property, this.$route.params[property]);
      }
      this.$refs["selectFilter"].query = Object.assign(
        this.$refs["selectFilter"].query,
        this.query
      );
    }
    // this.getData();
  },
};
</script>

<style lang="scss" scoped>
.el-tabs {
  width: 1350px;
  // margin-bottom: 10px;
}

/deep/.el-badge__content.is-fixed {
  top: 10px !important;
  right: 16px !important;
}

/deep/.el-tabs--top .el-tabs__item.is-top:last-child,
.el-tabs--top .el-tabs__item.is-bottom:last-child,
.el-tabs--bottom .el-tabs__item.is-top:last-child,
.el-tabs--bottom .el-tabs__item.is-bottom:last-child {
  padding-right: 20px !important;
}

.footer {
  height: 50px;
  width: 90%;
  margin: 10px auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
